import React from 'react';
import ContentLoader from 'react-content-loader';

const FlexTableSkeleton = (props) => (
  <ContentLoader
    speed={2}
    width={1086}
    height={500}
    viewBox="0 0 1086 500"
    backgroundColor="#f3f3f3"
    foregroundColor="#b1c8deca"
    {...props}
  >
    <rect x="0" y="110" rx="6" ry="6" width="1086" height="41" />
    <rect x="0" y="170" rx="5" ry="5" width="263" height="16" />
    <rect x="0" y="215" rx="5" ry="5" width="235" height="16" />
    <rect x="0" y="260" rx="5" ry="5" width="287" height="16" />
    <rect x="0" y="305" rx="5" ry="5" width="269" height="16" />
    <rect x="0" y="350" rx="5" ry="5" width="287" height="16" />
    <rect x="0" y="395" rx="5" ry="5" width="269" height="16" />
    <rect x="0" y="440" rx="5" ry="5" width="182" height="16" />
    <rect x="0" y="485" rx="5" ry="5" width="302" height="16" />
    <rect x="0" y="530" rx="5" ry="5" width="263" height="16" />
    <rect x="0" y="575" rx="5" ry="5" width="222" height="16" />
    <rect x="362" y="170" rx="5" ry="5" width="118" height="16" />
    <rect x="362" y="215" rx="5" ry="5" width="118" height="16" />
    <rect x="362" y="260" rx="5" ry="5" width="118" height="16" />
    <rect x="362" y="305" rx="5" ry="5" width="118" height="16" />
    <rect x="362" y="350" rx="5" ry="5" width="118" height="16" />
    <rect x="362" y="395" rx="5" ry="5" width="118" height="16" />
    <rect x="362" y="440" rx="5" ry="5" width="118" height="16" />
    <rect x="362" y="485" rx="5" ry="5" width="118" height="16" />
    <rect x="362" y="530" rx="5" ry="5" width="118" height="16" />
    <rect x="362" y="575" rx="5" ry="5" width="118" height="16" />
    <rect x="532" y="170" rx="5" ry="5" width="118" height="16" />
    <rect x="532" y="215" rx="5" ry="5" width="118" height="16" />
    <rect x="532" y="260" rx="5" ry="5" width="118" height="16" />
    <rect x="532" y="305" rx="5" ry="5" width="118" height="16" />
    <rect x="532" y="350" rx="5" ry="5" width="118" height="16" />
    <rect x="532" y="395" rx="5" ry="5" width="118" height="16" />
    <rect x="532" y="440" rx="5" ry="5" width="118" height="16" />
    <rect x="532" y="485" rx="5" ry="5" width="118" height="16" />
    <rect x="532" y="530" rx="5" ry="5" width="118" height="16" />
    <rect x="532" y="575" rx="5" ry="5" width="118" height="16" />
    <rect x="702" y="170" rx="5" ry="5" width="118" height="16" />
    <rect x="899" y="163" rx="5" ry="5" width="30" height="30" />
    <rect x="882" y="48" rx="5" ry="5" width="161" height="30" />
    <rect x="0" y="0" rx="1" ry="1" width="1" height="9" />
    <rect x="899" y="208" rx="5" ry="5" width="30" height="30" />
    <rect x="899" y="253" rx="5" ry="5" width="30" height="30" />
    <rect x="899" y="298" rx="5" ry="5" width="30" height="30" />
    <rect x="899" y="343" rx="5" ry="5" width="30" height="30" />
    <rect x="899" y="388" rx="5" ry="5" width="30" height="30" />
    <rect x="899" y="433" rx="5" ry="5" width="30" height="30" />
    <rect x="899" y="478" rx="5" ry="5" width="30" height="30" />
    <rect x="899" y="523" rx="5" ry="5" width="30" height="30" />
    <rect x="899" y="568" rx="5" ry="5" width="30" height="30" />
    <rect x="1013" y="163" rx="5" ry="5" width="30" height="30" />
    <rect x="1013" y="208" rx="5" ry="5" width="30" height="30" />
    <rect x="1013" y="253" rx="5" ry="5" width="30" height="30" />
    <rect x="1013" y="298" rx="5" ry="5" width="30" height="30" />
    <rect x="1013" y="343" rx="5" ry="5" width="30" height="30" />
    <rect x="1013" y="388" rx="5" ry="5" width="30" height="30" />
    <rect x="1013" y="433" rx="5" ry="5" width="30" height="30" />
    <rect x="1013" y="478" rx="5" ry="5" width="30" height="30" />
    <rect x="1013" y="523" rx="5" ry="5" width="30" height="30" />
    <rect x="1013" y="568" rx="5" ry="5" width="30" height="30" />
    <rect x="702" y="215" rx="5" ry="5" width="118" height="16" />
    <rect x="702" y="260" rx="5" ry="5" width="118" height="16" />
    <rect x="702" y="305" rx="5" ry="5" width="118" height="16" />
    <rect x="702" y="350" rx="5" ry="5" width="118" height="16" />
    <rect x="702" y="395" rx="5" ry="5" width="118" height="16" />
    <rect x="702" y="440" rx="5" ry="5" width="118" height="16" />
    <rect x="702" y="485" rx="5" ry="5" width="118" height="16" />
    <rect x="702" y="530" rx="5" ry="5" width="118" height="16" />
    <rect x="702" y="575" rx="5" ry="5" width="118" height="16" />
  </ContentLoader>
);

export { FlexTableSkeleton };
